const QueueEvent = {
    ADD_TO_QUEUE: 'ADD_TO_QUEUE',
    REPORT_STATE: 'REPORT_STATE',
}

/*
    Item of queue will be in following format:
    {
        taskId: 'string for task tracking',
        work: 'function for doing the real work'
    }
*/

export default {
    mounted() {
        let bus = this.getBusForQueue();
        bus.$on(QueueEvent.ADD_TO_QUEUE, this.handleAddToQueue);
        bus.$on(QueueEvent.REPORT_STATE, this.handleReportState);
    },

    destroyed() {
        this.getBusForQueue().$off(QueueEvent.ADD_TO_QUEUE, this.handleAddToQueue);
        this.getBusForQueue().$off(QueueEvent.REPORT_STATE, this.handleReportState);
    },

    data() {
        return {
            queue: [],
            currentProcessing: null
        }
    },

    methods: {
        consume() {
            if (this.currentProcessing) {
                return;
            }

            let item = this.queue.shift();
            if (item) {
                this.currentProcessing = item;
                console.log('Item ' + item.id + " is now processing...");
                item.task();
            } else {
                this.currentProcessing = null;
            }
        },

        handleAddToQueue(newItemForQueue) {
            console.log('Item ' + newItemForQueue.id + " added");
            this.queue.push(newItemForQueue);
            this.consume();
        },

        handleReportState(payload) {
            if (payload.id === this.currentProcessing.id) {
                this.currentProcessing = null;
                console.log('Item ' + payload.id + " is now: " + payload.state);
                this.consume();
            }
        },

        getBusForQueue() {
            console.error('Should return bus for queue');
        }
    }
}

export { QueueEvent };
